import { bindActionCreators, combineReducers } from 'redux';
import ServiceBase from '../service-base';
import reducerStore from '../reducer-store';
import Reducers from './reducers';
import * as Actions from './actions';

var util = {
    /**
     * 结合路由的url和传入的参数，返回目标url
     * @param {*} url 原始带参数链接
     * @param {*} params 参数
     */
    getTargetUrl: function (url, params) {
     
        var targetUrl = url;
        if (params && typeof params == 'object') {
            for (var key in params) {
                targetUrl = targetUrl.replace(new RegExp(`:${key}`, 'g'), params[key]);
            }
        }
        return targetUrl;
    },
    /**
     * 
     * @param {*} url 
     */
    getUrlKey: function (url) {
        var urlKey = util.hashCode(url.replace(/\/|:|http:\/\//g, ''));
        console.log(urlKey);
        return urlKey;
    },
    hashCode: function (str) {
        var hash = 0;
        if (str.length == 0) return hash;
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
}

/**
 * 
 * @param {*} url /pages/test/:a/:b
 */
export default function createService(
    url = ['/pages/test/:a/:b', '/pages/test/:a/:b'],
    params = { a: '', b: '' },
    initState = {
        isLoading: false,
        error: '',
        data: null
    }) {

    class Service extends ServiceBase {
        constructor(store) {
            super(store);
            // this.url = url;
            if (typeof url == 'string') {
                this.urls = [url];
            } else {
                this.urls = url
            }

            this.urlKey = util.getUrlKey(this.urls.join(''));
            this.config = {
                key: 'COMMON'
            }
            store.replaceReducer(reducerStore.add(this.config.key, Reducers));

            var state = store.getState()[this.config.key];
            initState = Object.assign(initState, state[this.urlKey] || {});
            store.dispatch(Actions.initData(this.urlKey, initState));
        }
        static reducer = {
            'COMMON': Reducers
        }
        static actions = Actions
        static loadData(params) {
            var targetUrl = util.getTargetUrl(url, params);
            var urlKey = util.getUrlKey(url);
            return Actions.loadData(urlKey, targetUrl)
        }
        getState() {
            var state = super.getState();
            return state[this.urlKey];
        }
        loadData(params) {
            var me = this;
            //分析参数
            if (me.urls.length == 1) {
                me.loadSingleData(params);
            } else {
                me.loadAllData(params);
            }
        }
        loadSingleData(params) {
            var me = this;
            var url = me.urls[0];
            var targetUrl = util.getTargetUrl(url, params);
            this.dispatch(Actions.loadData(me.urlKey, targetUrl));
        }
        loadAllData(params) {
            var me = this;
            var urls = me.urls || [];
            var targetUrls = urls.map(function (url) {
                return util.getTargetUrl(url, params);
            });
            this.dispatch(Actions.loadAllData(me.urlKey, targetUrls));
        }
    }

    return Service;
}


// WEBPACK FOOTER //
// ./_source/cqsx/services/create-service/index.js